/**
 *
 * @param {array} rawItems - required.
 * @param {object} options - required.
 * @param {string} options.keyParentValue - value to group by. required.
 * @param {string} options.keyValue - value for vuetify to base on. required.
 * @param {string} options.keyText - text value to display as. required.
 * @param {boolean} options.multiple - boolean value for whether to set header property or not for groups to render as vuetify header
 * @returns array for vuetify select components with addition of children property to set/unselect multiple values
 */
export default function(rawItems, options) {
  let items = rawItems;

  let childless = [];
  const groups = items.reduce((group, item) => {
    const { [options.keyParentValue]: parentId } = item;

    if (parentId) {
      if (group[parentId]) {
        group[parentId].children.push(item);
      } else {
        const parentItem = items.find(r => r[options.keyValue] == parentId);
        group[parentId] = {
          [options.keyValue]: parentId,
          [options.keyText]: parentItem[options.keyText],
          children: [item]
        };
      }

      return group;
    }

    if (!items.some(r => r[options.keyParentValue] == item[options.keyValue])) {
      // If item doesn't have any children, then push it into childless array
      childless.push(item);
    }

    return group;
  }, {});

  return [
    Object.values(groups)
      .map(group => {
        return [
          {
            [options.keyValue]: group[options.keyValue],
            [options.keyText]: group[options.keyText],
            header: options.multiple ? undefined : group[options.keyText], // when given truthy, vuetify will render it as header, not as item
            children: group.children // for being able to add/remove all of its chidlren ids/objects
          },
          { divider: true },
          {
            // when vuetify select has multiple prop, this actually doesn't just render which is okie
            // Needed in AppSelectCheckbox and single-select vuetify input to have the option itself be selectable
            [options.keyValue]: group[options.keyValue],
            [options.keyText]: group[options.keyText]
          },
          ...group.children
        ];
      })
      .flat(),
    { divider: true },
    childless
  ].flat();
}
